import { Component } from '@angular/core';
import { LOVABLE_SUGGESTED_USERS, LOVABLE_TRENDING_TOPICS } from './lovable-dashboard.models';

@Component({
    selector: 'app-lovable-right-rail',
    templateUrl: './lovable-right-rail.component.html',
    styleUrls: ['./lovable-right-rail.component.css'],
})
export class LovableRightRailComponent {
    readonly suggestedUsers = LOVABLE_SUGGESTED_USERS;
    readonly trendingTopics = LOVABLE_TRENDING_TOPICS;
}
